import axios from "axios";
import * as Icon from "react-feather";
import React from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { TicketingApiUri, apiKey } from "../constants";
import {
  getGlobalEndevreUser,
  checkIsEventAdmin,
  getOperatorStatus,
  getCachedGlobalUserState,
  setCachedGlobalUserState,
  getOrgDataByIDorCustomURL,
  getEndevreUser,
  // getEventDataHook,
} from "../hooks";
import Skeleton from "react-loading-skeleton";
import { Avatar } from "@mui/material";
import ProfileDropdown from "./navbar/ProfileDropdown";
import RoleCard from "./navbar/RoleCard";
import { motion, AnimatePresence } from "framer-motion";
import { Building2, Calendar } from "lucide-react";
import LayoutContext from "./LayoutContext";

// Workaround for framer-motion type issue
const MotionDiv = motion.div as any;

interface NavbarProps {
  fullScreen?: boolean;
}

interface EventData {
  status?: string;
  events?: {
    eventID: string;
    name: string;
    organizationID: string;
  };
}

interface VendorData {
  status?: string;
  vendors?: {
    vendorID: string;
    name: string;
    eventID: string;
  };
}

interface OrgData {
  organizationID: string;
  name: string;
}

interface GlobalUser {
  firstName?: string;
  organizations?: Array<{
    organizationID: string;
  }>;
}

export default function Navbar({ fullScreen }: NavbarProps) {
  const { pageTitle, setGlobalScopeEndevreUser } =
    React.useContext(LayoutContext) as any;

  // const { userNormalToken } = getEndevreID();
  const isFirstRunGUser = React.useRef(true);

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const isMenuCooldown = React.useRef(false);
  const { eventid, vendorid, orgid, customUrl } = useParams();
  const [eventData, setEventData] = React.useState<EventData>({});
  const [vendorData, setVendorData] = React.useState<VendorData>({});
  const [isVendor, setIsVendor] = React.useState(false);
  const [globalUser, setGlobalUser] = React.useState<GlobalUser | null>(
    isFirstRunGUser.current ? getCachedGlobalUserState({ debug: true }) : null
  );
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = React.useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] =
    React.useState(false);

  const [orgData, setOrgData] = React.useState<OrgData | null>(null);
  const [userIsInOrg, setUserIsInOrg] = React.useState(false);

  // const isAdmin = true;
  const authIDCookie = Cookies.get("authEventID");

  function toggleMenuHandler(state: boolean) {
    if (isMenuCooldown.current) return;
    setIsMenuOpen(state);
    // setIsMenuOpen((prev) => !prev);
  }

  React.useEffect(() => {
    async function getGUser() {
      let globalUserResponse = await getGlobalEndevreUser("global", "eventID");

      if (!globalUserResponse) {
        // user invalid log them out
        // let currEncodedURI = encodeURIComponent(
        //   "https://" + window.location.hostname + "/account"
        // );
        // // redirect to logout
        // window.location.href =
        //   "https://id.endevre.com/logout?silent&sID=Advent&spAU=" +
        //   currEncodedURI;
        // remove deviceid and usernormaltoken cookies
        // Cookies.remove("deviceID");
        // Cookies.remove("userNormalToken");
        // // go to log in page only if not on login page
        // if (window.location.pathname !== "/login") {
        //   window.location.href = "/login";
        // }
        // return null;
      }

      if (globalUserResponse) {
        setCachedGlobalUserState(globalUserResponse);
      }
      setGlobalUser(globalUserResponse);
      if (globalUserResponse) {
        setGlobalScopeEndevreUser(globalUserResponse);
      }
    }

    if (isFirstRunGUser.current) {
      isFirstRunGUser.current = false;

      // // used cached data if available
      // let cachedGlobalUser = getCachedGlobalUserState();
      // setGlobalUser(cachedGlobalUser);
      getGUser();
    }
  }, [setGlobalScopeEndevreUser]);

  React.useEffect(() => {
    console.log("GLOBAL USER UPDATED");

    console.log(globalUser);
  }, [globalUser]);

  React.useEffect(() => {
    async function getEventData(event_id: string) {
      let responseEvent = null;

      try {
        responseEvent = await axios.get(
          TicketingApiUri +
            "readevent.php?apikey=" +
            apiKey +
            "&eventID=" +
            event_id
        );
      } catch (error: any) {
        responseEvent = error.response;
      } finally {
        console.log(responseEvent.data);

        if (responseEvent.data.status !== "200") {
          // handle error
          return;
        }

        // check if user is admin
        let eventAdmin = await checkIsEventAdmin(
          event_id,
          responseEvent.data.events.organizationID
        );

        // check if user is vendor operator
        let vendorOperator = await getOperatorStatus(event_id);

        // check if user is vendor operator
        if (vendorOperator) {
          Cookies.set("authVendorID", vendorOperator, { expires: 1 });
          setIsVendor(true);
          getVendorData(vendorOperator, true);
        } else {
          Cookies.remove("authVendorID");
        }

        if (eventAdmin) {
          setIsAdmin(true);
        }

        setEventData(responseEvent.data);

        // set org stuff
        if (responseEvent.data.events?.organizationID) {
          fetchOrgData(responseEvent.data.events.organizationID);
        }
      }
    }

    async function getVendorData(vendor_id: string, bypassGetEvent = false) {
      let responseVendor = null;

      try {
        responseVendor = await axios.get(
          TicketingApiUri +
            "readvendor.php?apikey=" +
            apiKey +
            "&vendorID=" +
            vendor_id
        );
      } catch (error: any) {
        responseVendor = error.response;
      } finally {
        console.log(responseVendor.data);

        if (responseVendor.data.status !== "200") {
          // handle error
        }

        setVendorData(responseVendor.data);

        // setEventData(responseEvent.data);
        if (!bypassGetEvent) {
          getEventData(responseVendor.data.vendors.eventID);
        }
      }
    }

    let event_id = eventid !== undefined ? eventid : Cookies.get("authEventID"),
      vendor_id =
        vendorid !== undefined ? vendorid : Cookies.get("authVendorID");
    if (vendor_id !== undefined) {
      getVendorData(vendor_id);
    } else if (event_id !== undefined) {
      getEventData(event_id);
    }
  }, [eventid, vendorid, authIDCookie]);

  async function fetchOrgData(org_id: string) {
    let responseOrg = await getOrgDataByIDorCustomURL(org_id);

    console.log("THIS IS THE RESPONSE");
    console.log(responseOrg);

    if (responseOrg.status !== "200") {
      return;
    }

    setOrgData(responseOrg.organization);

    // check if user is in org
    let endevreIDResponse = await getEndevreUser();

    if (!endevreIDResponse) return;

    let userIsInOrg = endevreIDResponse.users.some(
      (org: any) => org.organizationID === responseOrg.organization.organizationID
    );

    console.log("USER IN ORG");
    console.log(userIsInOrg);

    setUserIsInOrg(userIsInOrg);
  }

  // get org data
  React.useEffect(() => {
    if (orgData || userIsInOrg) return;

    if (
      orgid !== undefined ||
      (customUrl !== undefined && customUrl?.length > 1)
    ) {
      // remove the @ in the first character of customurl
      let newCustomUrl = customUrl?.substring(1);
      let org_id = orgid || newCustomUrl;
      if (org_id) {
        fetchOrgData(org_id);
      }
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgid, customUrl]);

  // // check if user is in org
  // React.useEffect(() => {
  //   // check to make sure both orgData and globalUser are populated
  //   if (!orgData || !globalUser) return;

  //   // iterate through globalUser and check if orgID is in the array
  //   let userIsInOrg = globalUser.organizations.some(
  //     (org) => org.organizationID === orgData.organizationID
  //   );

  //   setUserIsInOrg(userIsInOrg);

  // }, [orgData, globalUser]);

  return (
    <>
      <nav className="transition-all duration-200 ease-in-out fixed w-full z-40">
        <div className="flex justify-center items-center px-4 py-[13px] bg-white border-b-2 border-slate-900/10 min-h-[70px]">
          <div className={" relative flex flex-col w-full"}>
            <div className={" flex w-full h-full justify-between items-left"}>
              <div className="flex flex-row gap-3 justify-center items-center">
                <a href="/" className="flex flex-row space-x-4 shrink-0">
                  <img
                    src={"/img/card_logo_color.svg"}
                    alt="Logo"
                    className="w-[38px] shrink-0"
                    // width={32}
                    // height={32}
                  />
                  <div
                    className={
                      (userIsInOrg ? "hidden sm:flex" : "") +
                      " flex flex-col items-end"
                    }
                  >
                    <span className="text-3xl text-black font-bold tracking-tight leading-none">
                      Advent
                    </span>
                    <span className="text-xs font-semibold tracking-tight leading-none text-slate-500">
                      by Endevre
                    </span>
                  </div>
                </a>
                {orgData && userIsInOrg ? (
                  <div className="flex flex-col h-full justify-end items-start border-l-2 pl-3 gap-0 shrink">
                    <div className="flex flex-row items-center justify-center gap-1">
                      <a
                        className="group"
                        href={"/organization/" + orgData?.organizationID}
                      >
                        <div className="flex flex-row items-center justify-center gap-1">
                          <Building2
                            className="group-hover:text-blue-900 transition-color duration-200"
                            size={12}
                            strokeWidth={1}
                          />
                          <p
                            className={
                              (eventData?.events?.name
                                ? "max-w-[calc(100dvw-750px)]"
                                : "max-w-[calc(100dvw-300px)]") +
                              " group-hover:text-blue-500 transition-color duration-200 text-xs truncate font-semibold text-gray-400"
                            }
                          >
                            {orgData?.name}
                          </p>
                        </div>
                      </a>
                      <p className="text-xs font-semibold text-slate-400">/</p>
                      {eventData?.events?.name ? (
                        <a
                          className="group"
                          href={"/admin/" + eventData?.events?.eventID}
                        >
                          <div className="flex flex-row items-center justify-center gap-1">
                            <Calendar
                              className="group-hover:text-blue-900 transition-color duration-200"
                              size={12}
                              strokeWidth={1}
                            />
                            <p className="group-hover:text-blue-500 transition-color duration-200 text-xs truncate font-semibold text-gray-400 max-w-[calc(100dvw-220px)] sm:max-w-[calc(100dvw-300px)]">
                              {eventData?.events?.name}
                            </p>
                          </div>
                        </a>
                      ) : null}
                    </div>
                    {/* <p className="text-base font-bold truncate max-w-[calc(100dvw-180px)]">{eventData?.events?.name || orgData?.name}</p> */}
                    <p className="text-base font-bold truncate max-w-[calc(100dvw-180px)]">
                      {pageTitle}
                    </p>
                  </div>
                ) : null}
              </div>
              <div className="flex flex-row justify-center items-center gap-2 md:gap-4 lg:gap-8">
                {/* {eventData?.events?.eventID? (
                  <div className="flex flex-col justify-center items-center">
                    <a href={"/event/" + eventData?.events?.eventID} className="relative transition-color duration-200 group w-8 h-8 flex justify-center items-center">
                      <Icon.Home className="text-slate-500 hover:text-slate-600" />
                    </a>
                  </div>
                ) : null } */}
                {!userIsInOrg ? (
                  <>
                    <div className="hidden md:block flex-col justify-center items-center">
                      <a
                        href="/"
                        className="relative transition-color duration-200 group flex justify-center items-center text-neutral-500 hover:text-neutral-600 text-sm tracking-normal"
                      >
                        {/* <Icon.Globe className="text-slate-500 hover:text-slate-600" /> */}
                        Features
                      </a>
                    </div>
                    <div className="hidden md:block flex-col justify-center items-center">
                      <a
                        href="/pricing"
                        className="relative transition-color duration-200 group flex justify-center items-center text-neutral-500 hover:text-neutral-600 text-sm tracking-normal"
                      >
                        {/* <Icon.Globe className="text-slate-500 hover:text-slate-600" /> */}
                        Pricing
                      </a>
                    </div>
                  </>
                ) : null}
                <div className="hidden md:block flex-col justify-center items-center">
                  <a
                    href="/docs"
                    className="relative transition-color duration-200 group flex justify-center items-center text-neutral-500 hover:text-neutral-600 text-sm tracking-normal"
                  >
                    {/* <Icon.Globe className="text-slate-500 hover:text-slate-600" /> */}
                    Docs
                  </a>
                </div>
                <div className="hidden md:block flex-col justify-center items-center">
                  <a
                    href="/browse"
                    className="relative transition-color duration-200 group flex justify-center items-center text-neutral-500 hover:text-neutral-600 text-sm tracking-normal"
                  >
                    {/* <Icon.Globe className="text-slate-500 hover:text-slate-600" /> */}
                    Browse
                  </a>
                </div>
                <div className="hidden md:block flex-col justify-center items-center">
                  <a
                    href="/create"
                    className="relative transition-color duration-150 group flex justify-center items-center text-blue-500 hover:text-blue-600 text-sm tracking-normal"
                  >
                    {/* <Icon.Globe className="text-slate-500 hover:text-slate-600" /> */}
                    Create Event
                  </a>
                </div>

                <div className="md:hidden flex flex-col justify-center items-center">
                  <button
                    className="relative transition-all duration-200 group w-8 h-8"
                    onClick={() => {
                      toggleMenuHandler(!isMoreMenuOpen);
                      setIsMoreMenuOpen(!isMoreMenuOpen);
                      setIsProfileDropdownOpen(false);
                    }}
                  >
                    {/* <Icon.Menu className="text-slate-500 hover:text-slate-600" /> */}
                    <Icon.Minus
                      size="30"
                      strokeWidth={1.5}
                      className={
                        (isMoreMenuOpen
                          ? "-translate-y-1/2 rotate-45"
                          : "-translate-y-[70%]") +
                        " transition-all duration-300 right-0 top-1/2 absolute text-slate-500 group-hover:text-slate-600"
                      }
                    />
                    <Icon.Minus
                      size="30"
                      strokeWidth={1.5}
                      className={
                        (isMoreMenuOpen ? "opacity-0" : "") +
                        " transition-all duration-300 right-0 top-1/2 -translate-y-1/2 absolute text-slate-500 group-hover:text-slate-600"
                      }
                    />
                    <Icon.Minus
                      size="30"
                      strokeWidth={1.5}
                      className={
                        (isMoreMenuOpen
                          ? "-translate-y-1/2 -rotate-45"
                          : "-translate-y-[30%]") +
                        " transition-all duration-300 right-0 top-1/2 absolute text-slate-500 group-hover:text-slate-600"
                      }
                    />
                  </button>
                </div>
                {globalUser ? (
                  <div className="flex flex-col justify-center items-center">
                    <button
                      className="relative transition-all duration-200 group w-8 h-8 hover:shadow-md rounded-full"
                      onClick={() => {
                        toggleMenuHandler(!isProfileDropdownOpen);
                        setIsProfileDropdownOpen(!isProfileDropdownOpen);
                        setIsMoreMenuOpen(false);
                      }}
                    >
                      <Avatar
                        sx={globalUser?.firstName ? { bgcolor: "#0b84fe" } : {}}
                        style={{
                          width: "100%",
                          height: "100%",
                          fontFamily: "Inter",
                          fontWeight: 600,
                        }}
                      >
                        {globalUser?.firstName?.substring(0, 1)}
                      </Avatar>
                    </button>
                  </div>
                ) : (
                  <a
                    href="/login"
                    className="flex flex-col justify-center items-center py-1.5 px-2.5 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200 ease-in-out"
                  >
                    <p className="hidden sm:block relative transition-color duration-200 group flex justify-center items-center font-semibold text-sm tracking-normal text-white">
                      Sign In / Sign Up
                    </p>
                    <p className="sm:hidden relative transition-color duration-200 group flex justify-center items-center font-semibold text-sm tracking-normal text-white">
                      Sign In
                    </p>
                  </a>
                )}
              </div>
              {/* <div className="hidden sm:flex flex-row justify-center items-center space-x-4">
                <button className="transition-color duration-200">
                  <Icon.Layout className="text-slate-500 hover:text-slate-600" />
                </button>
                <button className="transition-color duration-200">
                  <Icon.User className="text-slate-500 hover:text-slate-600" />
                </button>
              </div> */}
            </div>

            <div
              className={
                (isMoreMenuOpen ? "max-h-screen" : "max-h-0") +
                " h-fit transition-all duration-200 ease-in-out flex flex-col justify-start items-end overflow-hidden gap-2 z-50"
              }
            >
              {isVendor ? (
                <div className="flex flex-col justify-center items-start w-full rounded-xl bg-slate-200 p-4 mt-3">
                  <h1 className="font-bold text-lg text-slate-900">
                    Vendor Operator
                  </h1>
                  <p className="font-normal text-sm text-slate-700">
                    This device is currently designated as a vendor operator.
                  </p>

                  <div className="flex flex-col space-y-1 mt-3 w-full">
                    <div className="flex flex-row space-x-3 items-center justify-between sm:justify-start">
                      <div className="flex flex-row space-x-2 items-center justify-start sm:w-40">
                        <h1 className="font-semibold text-xs text-slate-500 uppercase tracking-wide w-16">
                          Event
                        </h1>
                        <h1 className="text-sm text-slate-600 tracking-normal text-start">
                          [
                          <span className="font-mono uppercase">
                            {eventData.events !== undefined
                              ? eventData.events.eventID
                              : ""}
                          </span>
                          ]
                        </h1>
                      </div>
                      <h1 className="text-sm text-slate-600 tracking-normal truncate w-full text-start">
                        <span className="font-semibold">
                          {eventData.events !== undefined ? (
                            eventData.events.name
                          ) : (
                            <Skeleton />
                          )}
                        </span>
                      </h1>
                    </div>
                    <div className="flex flex-row space-x-3 items-center justify-between sm:justify-start">
                      <div className="flex flex-row space-x-2 items-center justify-start sm:w-40">
                        <h1 className="font-semibold text-xs text-slate-500 uppercase tracking-wide w-16">
                          Vendor
                        </h1>
                        <h1 className="text-sm text-slate-600 tracking-normal text-start">
                          [
                          <span className="font-mono uppercase">
                            {vendorData.vendors !== undefined
                              ? vendorData.vendors.vendorID
                              : ""}
                          </span>
                          ]
                        </h1>
                      </div>
                      <h1 className="text-sm text-slate-600 tracking-normal truncate w-full text-start">
                        <span className="font-semibold">
                          {vendorData.vendors !== undefined ? (
                            vendorData.vendors.name
                          ) : (
                            <Skeleton />
                          )}
                        </span>
                      </h1>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <a
                href="/"
                className={
                  (isMoreMenuOpen ? "" : "-translate-y-6") +
                  " transition-color duration-300 ease-in-out text-sm text-neutral-400 hover:text-neutral-500 tracking-normal py-1 mt-4"
                }
              >
                Features
              </a>
              <a
                href="/pricing"
                className={
                  (isMoreMenuOpen ? "" : "-translate-y-6") +
                  " transition-color duration-300 ease-in-out text-sm text-neutral-400 hover:text-neutral-500 tracking-normal py-1"
                }
              >
                Pricing
              </a>
              <a
                href="/docs"
                className={
                  (isMoreMenuOpen ? "" : "-translate-y-6") +
                  " transition-color duration-300 ease-in-out text-sm text-neutral-400 hover:text-neutral-500 tracking-normal py-1"
                }
              >
                Docs
              </a>
              <a
                href="/browse"
                className={
                  (isMoreMenuOpen ? "" : "-translate-y-6") +
                  " transition-color duration-300 ease-in-out text-sm text-neutral-400 hover:text-neutral-500 tracking-normal py-1"
                }
              >
                Browse
              </a>
              <a
                href="/create"
                className={
                  (isMoreMenuOpen ? "" : "-translate-y-6") +
                  " transition-color duration-300 ease-in-out text-sm text-blue-500 hover:text-blue-600 tracking-normal py-1"
                }
              >
                Create Event
              </a>
            </div>
          </div>
        </div>
      </nav>
      <AnimatePresence>
        {isProfileDropdownOpen ? (
          <MotionDiv
            style={{
              position: 'fixed',
              height: '100%',
              width: '100%',
              zIndex: 40,
              top: '70px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
              padding: '1rem',
            }}
            onClick={() => {
              toggleMenuHandler(!isMenuOpen);
              setIsMoreMenuOpen(false);
              setIsProfileDropdownOpen(false);
            }}
            initial={{ opacity: 0, x: "25%" }}
            animate={{ opacity: 1, x: "0%" }}
            exit={{ opacity: 0, x: "25%" }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <div className="flex flex-col items-end w-full gap-4">
              <ProfileDropdown
                isMenuOpen={isProfileDropdownOpen}
                globalUser={globalUser}
                isAdmin={isAdmin}
              />
              <RoleCard
                isMenuOpen={isProfileDropdownOpen}
                globalUser={globalUser}
                isAdmin={eventData.events !== undefined && isAdmin}
                eventData={eventData?.events}
                role={eventData.events && isAdmin ? "admin" : undefined}
                isShown={eventData.events}
              />
            </div>
          </MotionDiv>
        ) : null}
      </AnimatePresence>
      <div className="h-full min-h-[70px] max-h-[70px] w-full"></div>
    </>
  );
}
